import React, { useEffect, useState } from "react";
import PhoneBundles from "@components/common/widgets/PhoneBundles";
import PromoSlider from "@components/common/widgets/PromoSlider";
import ScrollingAD from "@components/phone/ScrollingAD";
import Roaming from "@components/common/widgets/Roaming";
import Footer from "@components/common/footer/Footer";

import PhoneList from "@components/phone/PhoneList";
import BreadcrumbWithoutAjax from "@components/common/BreadcrumbWithoutAjax";
import Global from "@/Global";
import Navigation from "@components/common/Navigation/Navigation";
import FloatingActionButton from "@components/common/FloatingActionButton";

export default function SmartPhoneApp() {
  const [categoryData, setCategoryData] = useState([]);

  useEffect(() => {
    async function fetchPheDetail() {
      let response = await fetch(Global.getAPI("phone-detail"));
      if (response.status >= 400) throw new Error("Error API: phone-detail");
      let responseJson = await response.json();

      setCategoryData(responseJson.generalLabels.category);
    }

    fetchPheDetail();
  }, []);

  return (
    <div className="row-height-100">
      <Navigation />
      <main>
        <PromoSlider urlAPI="promoslider.smartphones" />
        <BreadcrumbWithoutAjax categoryData={categoryData} />
        <PhoneList isDefaultFiveG={false} />
        <PhoneBundles theme="purple" apiCallPath={"smartphone-bundles"} />
        <ScrollingAD apiCallPath={"smartphone-banners"} />
        <Roaming urlAPI="smartphone-promo" />
      </main>
      <Footer />
      <FloatingActionButton/>
    </div>
  );
}
